var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    { attrs: { label: _vm.label } },
    [
      _c(
        "v-select",
        {
          class: { "v-select-danger": _vm.danger, "select-size-sm": _vm.small },
          attrs: {
            name: _vm.name,
            value: _vm.optionSelected,
            options: _vm.paginatedValues,
            disabled: _vm.isDisabled,
            filterable: false,
            clearable: _vm.isClearable,
            placeholder: _vm.placeholder,
            multiple: _vm.isMultiple
          },
          on: {
            search: _vm.onSearch,
            input: _vm.onInput,
            "search:focus": _vm.onFocus
          },
          scopedSlots: _vm._u([
            {
              key: "spinner",
              fn: function() {
                return [
                  _vm.usersState.loading
                    ? _c("b-spinner", {
                        style: { opacity: _vm.usersState.loading ? 1 : 0 },
                        attrs: { small: "", variant: "primary" }
                      })
                    : _vm._e()
                ]
              },
              proxy: true
            },
            {
              key: "option",
              fn: function(ref) {
                var value = ref.value
                var label = ref.label
                var iut = ref.iut
                return [
                  _c(
                    "span",
                    {
                      attrs: {
                        "data-cy-iut": iut,
                        "data-cy-value": value,
                        "data-cy-label": label
                      }
                    },
                    [_vm._v(" " + _vm._s(label) + " ")]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "no-options" }, [
            _vm._v(" escribe para buscar usuarios.. ")
          ]),
          _vm.hasNextPage
            ? _c(
                "li",
                {
                  staticClass: "pagination",
                  attrs: { slot: "list-footer" },
                  slot: "list-footer"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block btn-primary btn-sm",
                      attrs: { type: "button", disabled: !_vm.hasNextPage },
                      on: { click: _vm.searchPage }
                    },
                    [_vm._v(" buscar mas usuarios... ")]
                  )
                ]
              )
            : _vm._e()
        ],
        2
      ),
      _vm.withFilters
        ? _c(
            "div",
            { staticClass: "d-flex mt-1" },
            [
              _c(
                "b-form-radio",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.bottom",
                      value:
                        "Selecciona y escribe el nombre para encontrar usuarios",
                      expression:
                        "'Selecciona y escribe el nombre para encontrar usuarios'",
                      modifiers: { hover: true, bottom: true }
                    }
                  ],
                  staticClass: "mr-5",
                  attrs: { name: "label", value: "label" },
                  model: {
                    value: _vm.filterBy,
                    callback: function($$v) {
                      _vm.filterBy = $$v
                    },
                    expression: "filterBy"
                  }
                },
                [_vm._v(" Por nombre ")]
              ),
              _c(
                "b-form-radio",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.bottom",
                      value:
                        "Selecciona y escribe el rut para encontrar usuarios",
                      expression:
                        "'Selecciona y escribe el rut para encontrar usuarios'",
                      modifiers: { hover: true, bottom: true }
                    }
                  ],
                  staticClass: "mr-5",
                  attrs: { name: "iut", value: "iut" },
                  model: {
                    value: _vm.filterBy,
                    callback: function($$v) {
                      _vm.filterBy = $$v
                    },
                    expression: "filterBy"
                  }
                },
                [_vm._v(" Por rut ")]
              ),
              _c(
                "b-form-radio",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.bottom",
                      value:
                        "Selecciona y escribe el cargo para encontrar usuarios",
                      expression:
                        "'Selecciona y escribe el cargo para encontrar usuarios'",
                      modifiers: { hover: true, bottom: true }
                    }
                  ],
                  staticClass: "mr-5",
                  attrs: { name: "position", value: "position" },
                  model: {
                    value: _vm.filterBy,
                    callback: function($$v) {
                      _vm.filterBy = $$v
                    },
                    expression: "filterBy"
                  }
                },
                [_vm._v(" Por cargo ")]
              ),
              _c(
                "b-form-radio",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.bottom",
                      value:
                        "Selecciona y escribe el correo para encontrar usuarios",
                      expression:
                        "'Selecciona y escribe el correo para encontrar usuarios'",
                      modifiers: { hover: true, bottom: true }
                    }
                  ],
                  staticClass: "mr-5",
                  attrs: { name: "email", value: "email" },
                  model: {
                    value: _vm.filterBy,
                    callback: function($$v) {
                      _vm.filterBy = $$v
                    },
                    expression: "filterBy"
                  }
                },
                [_vm._v(" Por correo ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.danger
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger v-enter-to",
              staticStyle: { height: "19px" }
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.dangerText) + " ")
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }